import { deprecated } from "typesafe-actions";

import type { IAppStructureNode } from "@/shop/types/appStructure";

import { AppStructureActionType } from "./constants";

const { createStandardAction } = deprecated;

export const fetchAppStructure = createStandardAction(AppStructureActionType.FETCH_APP_STRUCTURE).map((payload: string) => ({
  payload
}));
export const fetchAppStructureStart = createStandardAction(AppStructureActionType.FETCH_APP_STRUCTURE_START)();
export const fetchAppStructureSuccess = createStandardAction(AppStructureActionType.FETCH_APP_STRUCTURE_SUCCESS)<IAppStructureNode[]>();
export const fetchAppStructureFail = createStandardAction(AppStructureActionType.FETCH_APP_STRUCTURE_FAIL).map((payload: Error) => ({
  payload,
  error: true
}));
